module.exports = __webpack_public_path__ + "static/etctrispace-regularnarrow-webfont-a13eddd5baa7bd38ad27a6bbddb44245.woff2";